import ToastNotification from "./notification";
import ReactDOM from "react-dom";
import ConfirmModal from "./modal-confirm";

export default class UniMachineModalElement {
  body = document.getElementsByTagName("body");
  machineRoot = document.createElement("machine-modal");
  constructor() {
    this.body[0].append(this.machineRoot);
  }
  Loading(load: any) {
    const className = load ? "d-block" : "d-none";
    const body = document.querySelector("body") as any;
    const loading = document.createElement("div");
    const spinning = document.createElement("div");
    loading.className = "loading " + className;
    spinning.className = "spinning spinner-border text-primary";
    loading.appendChild(spinning);

    if (document.querySelector(".loading")) {
      const loadingC = [...(document.querySelectorAll(".loading") as any)];
      for (let i = 0; i < loadingC.length; i++) {
        loadingC[i].remove();
      }
    }
    body.append(loading);
  }
  ModalConfirm(props: { show: any; message: any }) {
    const { show, message } = props;
    function submit(callBack: () => void) {
      // history.replaceState({}, null, '/auth/login')
      // history.go()
      callBack();
    }
    ReactDOM.unmountComponentAtNode(this.machineRoot);
    ReactDOM.render(
      <ConfirmModal
        confirm={{
          show,
          description: message,
          title: "notification",
          confirmAction: submit,
          confirmText: "confirm",
        }}
      />,
      this.machineRoot
    );
  }
  Notification(props: any) {
    const { show, message, type } = props;
    ReactDOM.unmountComponentAtNode(this.machineRoot);
    ReactDOM.render(
      <ToastNotification
        notification={{
          show,
          longText: message,
          type,
          shortText: "notification",
        }}
      />,
      this.machineRoot
    );
  }
}
